import { t } from 'i18next'
import { Trans } from 'react-i18next'

import { Icon } from '@/shared/components/icon'

export const SemCondicaoDePreco = () => {
  return (
    <div className="flex h-full flex-1 flex-col items-center px-8 py-16">
      <div>
        <div className="absolute size-25 rounded-full bg-orange-100" />
        <Icon className="relative mb-6 size-25 p-3 text-gray-600" name="blocks" strokeWidth={4} />
      </div>
      <h2 className="mb-1 text-center text-xl leading-8 font-semibold tracking-wide text-gray-600">
        {t('espelho-de-vendas:sem_condicao_preco.titulo')}
      </h2>
      <p className="font-nunito text-center leading-relaxed tracking-wide text-gray-900">
        <Trans t={t} i18nKey="espelho-de-vendas:sem_condicao_preco.descricao" components={{ br: <br /> }} />
      </p>
    </div>
  )
}
